<template>
  <div style="user-select: none; cursor: default;">
    <div v-if="loader.getSystemInformationData || loader.selectCRMAgentsFromCRMAgentsView" style="width: 100%; height: 100vh; display: flex; justify-content: center; align-items: center;">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <div v-else-if="systemInformationData.CRMAgent != null">
      <v-card color="borderInner" elevation="0" rounded="0" style="height: 100vh; overflow-y: hidden; display: flex; flex-direction: column;">
        <div style="align-items: center; margin: 15px;">
          <v-text-field 
            ref="searchQuery"
            v-model="input.searchQuery"
            label="Búsqueda rápida" 
            variant="solo-filled" 
            density="compact" 
            @click:append-inner="$generalFunctions.default.blurInput(this, 'searchQuery'); input.searchQuery = null"
            :append-inner-icon="input.searchQuery && /\S/.test(input.searchQuery) ? 'mdi-magnify-remove-outline' : 'mdi-magnify'"
            hide-details
            autocomplete="off"
          ></v-text-field>
        </div>

        <v-data-table :headers="display.CRMAgentsHeaders" :items="filteredAndSortedCRMAgents" :fixed-header="true" :items-per-page="filteredAndSortedCRMAgents.length > 100 ? 100 : -1" style="flex: 1; overflow-y: auto;">
          <template v-slot:header.CRMAgentName>
            <p><strong>AGENTE</strong></p>
          </template>
          <template v-slot:header.CRMAgentSSN>
            <p><strong>SSN</strong></p>
          </template>
          <template v-slot:header.CRMAgentStatus>
            <p><strong>ESTADO (RECIBIR MENSAJES)</strong></p>
          </template>
          <template v-slot:header.CRMAgentLoginPermission>
            <p><strong>ESTADO (INICIAR SESIÓN)</strong></p>
          </template>
          <template v-slot:item.CRMAgentName="{ item }">
            <v-chip :color="item.CRMAgentColor || 'primary'" variant="flat" elevation="2" label>
              <div style="display: flex; align-items: center;">
                <img :src="item.CRMAgentProfilePictureURL || require('@/assets/images/CRMAgentProfilePicturePlaceholder.png')" draggable="false" style="width: 30px; height: 30px; border-radius: 50%; object-fit: cover; margin-right: 10px;">
                <p :style="{ color: item.CRMAgentFontColor || '', margin: 0 }">{{ item.CRMAgentName || 'No registrado' }}</p>
              </div>
            </v-chip>
          </template>
          <template v-slot:item.CRMAgentStatus="{ item }">
            <v-icon 
              @click="updateCRMAgentStatus(item)" 
              :disabled="item.updateCRMAgentStatusLoader || item.assignCRMAgentPermissionLoader" 
              :color="item.CRMAgentStatus == 'active' ? 'success' : 'error'" 
              class="CRMAgentStatusIcon"
            >
            mdi-circle
            </v-icon>
          </template>
          <template v-slot:item.CRMAgentLoginPermission="{ item }">
            <v-switch 
              v-model="item.CRMAgentLoginPermission" 
              :disabled="item.updateCRMAgentStatusLoader || item.assignCRMAgentPermissionLoader" 
              @change="assignCRMAgentPermission(item)"
              color="primary"
              hide-details
            ></v-switch>
          </template>
          <template v-slot:item.CRMAgentProfile="{ item }">
            <v-btn @click="$generalFunctions.default.navigateTo(`/CRMAgent/${item.CRMAgentID}`)" color="primary" variant="outlined" size="small">
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>

          <template v-if="filteredAndSortedCRMAgents.length <= 100" v-slot:bottom></template>
        </v-data-table>


      </v-card>
    </div>
  </div>
</template>

<style scoped>
  @keyframes pulse {
    0% { 
      transform: scale(1);
      filter: brightness(1);
    }
    50% { 
      transform: scale(1.1);
      filter: brightness(1.2);
    }
    100% { 
      transform: scale(1);
      filter: brightness(1);
    }
  }

  .CRMAgentStatusIcon {
    cursor: pointer;
    border-radius: 50%;
    padding: 4px;
    animation: pulse 3s ease-in-out infinite;
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
  }

</style>

<script>
  import { systemInformation } from '@/utilities/systemInformation';
  import websocket from '@/utilities/websocket';
  export default {
    inject: ['$generalFunctions', '$displayFunctions'],
    data: () => ({
      input: 
      {
        searchQuery: null
      },
      display: 
      {
        CRMAgentsHeaders: 
        [
          {title: 'NOMBRE', key: 'CRMAgentName', sortable: false},
          {title: 'SSN', key: 'CRMAgentSSN', sortable: false},
          {title: 'ESTADO (RECIBIR MENSAJES)', key: 'CRMAgentStatus', sortable: false},
          {title: 'ESTADO (INICIAR SESIÓN)', key: 'CRMAgentLoginPermission', sortable: false},
          {title: 'PERFIL', key: 'CRMAgentProfile', sortable: false}
        ],
        CRMAgents: []
      },
      loader: 
      {
        getSystemInformationData: false,
        selectCRMAgentsFromCRMAgentsView: false
      },
      websocketCallback: 
      {
        updateCRMAgentStatus: null
      },
      systemInformationData: 
      {
        CRMAccountID: null,
        CRMAgent: null,
        tooltipDisabled: false,
        updateSubscription: null
      }
    }),

    computed: {
      filteredAndSortedCRMAgents(){
        let filteredAndSortedCRMAgents = this.display.CRMAgents;
        if (this.input.searchQuery) filteredAndSortedCRMAgents = filteredAndSortedCRMAgents.filter(CRMAgent => CRMAgent.CRMAgentName.toLowerCase().includes(this.input.searchQuery.toLowerCase()) || CRMAgent.CRMAgentSSN.toLowerCase().includes(this.input.searchQuery.toLowerCase()));
        return filteredAndSortedCRMAgents;
      }
    },

    methods: {

      async selectCRMAgentsFromCRMAgentsView(){
        this.loader.selectCRMAgentsFromCRMAgentsView = true;
        const selectCRMAgentsFromCRMAgentsViewRequestQuery = 
        {
          'localStorage':
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID
          }
        };
        const selectCRMAgentsFromCRMAgentsViewResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/selectCRMAgentsFromCRMAgentsView', selectCRMAgentsFromCRMAgentsViewRequestQuery);
        if (selectCRMAgentsFromCRMAgentsViewResult.success){
          this.display.CRMAgents = selectCRMAgentsFromCRMAgentsViewResult.result;
          this.loader.selectCRMAgentsFromCRMAgentsView = false;
        } else {
          this.$root.notificationDialog.showSystemNotificationDialog('selectCRMAgentsFromCRMAgentsView_error', 'error', 'Ha ocurrido un error inesperado al obtener la lista de agentes, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
      },

      async updateCRMAgentStatus(CRMAgent) {
        CRMAgent.updateCRMAgentStatusLoader = true;
        const updateCRMAgentStatusRequestQuery = 
        { 
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': CRMAgent.CRMAgentID
          },
          'CRMAgentStatus': CRMAgent.CRMAgentStatus == 'active' ? 'inactive' : 'active'
        }
        CRMAgent.CRMAgentStatus = CRMAgent.CRMAgentStatus == 'active' ? 'inactive' : 'active';
        const updateCRMAgentStatusResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/updateCRMAgentStatus', updateCRMAgentStatusRequestQuery);
        if (!updateCRMAgentStatusResult.success){
          CRMAgent.CRMAgentStatus = CRMAgent.CRMAgentStatus == 'active' ? 'inactive' : 'active';
          this.$root.notificationDialog.showSystemNotificationDialog('updateCRMAgentStatus_error', 'error', 'Ha ocurrido un error inesperado al actualizar el estado del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        }
        CRMAgent.updateCRMAgentStatusLoader = false;
      },

      async assignCRMAgentPermission(CRMAgent){
        CRMAgent.assignCRMAgentPermissionLoader = true;
        const assignCRMAgentPermissionRequestQuery = 
        {
          'localStorage': 
          {
            'CRMAccountID': this.systemInformationData.CRMAccountID,
            'CRMAgentID': this.systemInformationData.CRMAgent.CRMAgentID
          },
          'CRMAgentPermissionCRMAgentID': CRMAgent.CRMAgentID,
          'CRMAgentPermissionName': '/login',
          'CRMAgentPermissionType': 'boolean',
          'CRMAgentPermissionValue': CRMAgent.CRMAgentLoginPermission,
          'CRMAgentPermissionExpirationInterval': null
        };
        const assignCRMAgentPermissionResult = await this.$generalFunctions.default.executeHttpPOSTRequest('/CRMAgent/functions/assignCRMAgentPermission', assignCRMAgentPermissionRequestQuery);
        if (!assignCRMAgentPermissionResult.success){
          CRMAgent.CRMAgentLoginPermission = !CRMAgent.CRMAgentLoginPermission;
          this.$root.notificationDialog.showSystemNotificationDialog('assignCRMAgentPermission_error', 'error', 'Ha ocurrido un error inesperado al actualizar el permiso de inicio de sesión del agente, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, true);
        } 
        CRMAgent.assignCRMAgentPermissionLoader = false;
      },


      connectWebsocket(){
        websocket.connectWebsocket();
        this.websocketCallback.updateCRMAgentStatus = async (websocketMessageData) => {
          const updatedCRMAgent = this.display.CRMAgents.find(CRMAgent => CRMAgent.CRMAgentID == websocketMessageData.websocketMessageContent.CRMAgentID);
          if (updatedCRMAgent) updatedCRMAgent.CRMAgentStatus = websocketMessageData.websocketMessageContent.CRMAgentStatus;
        };
        if (this.websocketCallback.updateCRMAgentStatus) websocket.addWebsocketMessageListener('/CRMAgent/functions/updateCRMAgentStatus', this.websocketCallback.updateCRMAgentStatus);
      },

      disconnectWebsocket(){
        if (this.websocketCallback.updateCRMAgentStatus) websocket.removeWebsocketMessageListener('/CRMAgent/functions/updateCRMAgentStatus', this.websocketCallback.updateCRMAgentStatus);
        this.websocketCallback.updateCRMAgentStatus = null;
      },

      async getSystemInformationData() {
        try {
          this.loader.getSystemInformationData = true;
          systemInformation.setGeneralFunctions(this.$generalFunctions.default);
          const systemInformationResult = await systemInformation.startup();
          if (systemInformationResult.success){
            this.systemInformationData.CRMAccountID = systemInformation.getCRMAccountID;
            this.systemInformationData.CRMAgent = systemInformation.getCRMAgent;
            this.systemInformationData.tooltipDisabled = systemInformation.getTooltipDisabled;
            this.systemInformationData.updateSubscription = systemInformation.subscribeToUpdate((updatedSystemInformationData) => {
              this.systemInformationData.tooltipDisabled = updatedSystemInformationData.tooltipDisabled;
            });
            this.loader.getSystemInformationData = false;
          } else {
            this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
          }
        } catch {
          this.$root.notificationDialog.showSystemNotificationDialog('getSystemInformation_error', 'error', 'Ha ocurrido un error inesperado al obtener la información del sistema, por favor intente nuevamente. Si el problema persiste consulte a su administrador de sistema', null, false);
        }
      }
    },

    async mounted() {
      await this.getSystemInformationData();
      await this.selectCRMAgentsFromCRMAgentsView();
      this.$generalFunctions.default.focusInput(this, 'searchQuery');
      this.connectWebsocket();
    },

    beforeUnmount() {
      this.disconnectWebsocket();
    }
  }
</script>
